import classNames from "classnames";
import React from "react";
import { DashboardUtils } from "../../../dashboard_utils";
import { WithTooltip } from "../tooltips/with_tooltip";

export function ListingsFormTableData(props: {
	content: string;
	bolded?: boolean;
}) {
	const { content, bolded } = props;

	return (
		<td>
			<WithTooltip tooltip={content} style={"Info"}>
				<div className="flex w-full">
					<p
						className={classNames(
							"ellipsis-overflow w-full overflow-hidden whitespace-nowrap",
							{
								"font-bold": bolded,
							}
						)}
					>
						{content}
					</p>
				</div>
			</WithTooltip>
		</td>
	);
}
